<template>
  <div>
    <h3>选择科室</h3>
    <h5>点击即可选择</h5>
    <box-header>
      <Row slot="left">
        <Button type="error" icon="ios-close-circle-outline" @click="clear">清除选择</Button>
      </Row>
      <Row slot="right">
        <Input placeholder="科室名称" style="width:200px;margin-left:250px" search v-model="query.deskName" @on-search="search" @on-enter="search" />
        <!-- <Input placeholder="手机号" style="width:200px;" search v-model="query.phonenumber" @on-search="search" @on-enter="search" /> -->
      </Row>
    </box-header>
    <Row>
      <edit-table ref="tablelist" :output="false" :url="url" :query="query" :table="table" :savepage="false" :columns-list="tableCols" @on-click="clickRow"></edit-table>
    </Row>
  </div>
</template>
<script>
export default {
  name: 'popOffice',
  components: {},
  props: {
    name: String,
    query: {
      type: Object,
      default: () => {
        return {
          deskName: '',
          // user_mobile: '',
        }
      },
    },
  },
  data() {
    return {
      url: '',
      // query: {     // 用props的query替换
      // },
      table: {
        // tname: 'offices',
        mname:'offices',
        key: 'id',
        url: {
          list: `/admin/system/desk/list/?isParent=${"0"}`,
          // list: 'userList',
        },
      },
      tableCols: [
        {
          title: 'UID',
          key: 'id',
          width: 100,
          align: 'center',
        },
        {
          title: '科室名称',
          key: 'deskName',
          minWidth: 100,
        },
        {
          title: '楼宇楼层',
          key: 'address',
          minWidth: 100,
        },
      ],
    }
  },
  watch: {
    query(v) {
      // this.search()
    },
  },
  created() {},
  mounted() {
    this.search()
  },
  methods: {
    search() {
      // this.$refs.tablelist.page.page = 1
      this.$refs.tablelist.init()
    },
    clear() {
      this.$emit('on-clear', null)
    },
    clickRow(row, index) {
      this.$emit('on-click', row)
    },
  },
}
</script>
<style lang="less"></style>
